import type { BundleDto } from '../../types/composite/BundleTypes';
import { buildUrl } from '../../utils/fetcher';

export const fetchUnitCollectionData = async (unitId: string) => {
  const url = buildUrl(`/bundles/${unitId}`, '/composite', '/v1');
  const response = await fetch(url);
  if (!response.ok) {
    throw Error(`Response: ${response.status}`);
  }
  return (await response.json()) as BundleDto;
};
